// @ts-nocheck
import { REGEX } from '../Password_Rules/Password_Rules';

export const emailValidation = {
  validate: async (value: string): Promise<void> => {
    if (!value || value.trim().length === 0) {
      throw new Error('Email address is required');
    }
    if (!REGEX.EMAIL.test(value)) {
      throw new Error('Please enter a valid email address');
    }
  },
};
